import React from "react";
import {Link} from "@bonprix/design-system";

export default function ToSustainabilityCategoryDetails({text, onClick}) {
    if(!text) {
        return <></>;
    }
    return (<div className={"sustainability-to-category-details"}
                onClick={onClick}>
        <Link href={null}
              arrowPosition={"right"}
              showArrow>
            {text}
        </Link>
    </div>);
}